(function(Drupal, $) {
  Drupal.behaviors.bodyCopy = {
    attach: function(context) {
      $(".body-copy", context)
        .once("processed")
        .addClass("processed")
        .children("img")
        .each(function() {
          var $this = $(this);
          $this.wrap("<div class='image-wrapper'></div>");
          if ($this.data("caption")) {
            $this
              .parent()
              .after(
                "<div class='image-caption'>" + $this.data("caption") + "</div>"
              );
          }
        });
    }
  };
})(Drupal, jQuery);
